import { computed, nextTick, ref } from 'vue'
import { Link, SquareMenu, Tags } from 'lucide-vue-next'
import { createDropdown, createLink, createCategories, useSelectedItem } from '@/Components/Navigation'

export function useNavigationItems() {
  const items = ref({})

  const { selectedItem, selectItem, deselectItem } = useSelectedItem()

  const addItem = (item, parent = null) => {
    const clone = JSON.parse(JSON.stringify(items.value))

    // ensure it is always at the end
    const order = Object.keys(items.value).length

    items.value = {
      ...clone,
      [item.id]: {
        ...item,
        ...(parent ? { parent_id: parent.id } : {}),
        viewport: {
          mobile: {
            ...item.viewport.mobile,
            order
          },
          tablet: {
            ...item.viewport.tablet,
            order
          },
          desktop: {
            ...item.viewport.desktop,
            order
          }
        }
      },
    }

    nextTick(() => {
      selectItem(items.value[item.id])

      // Scroll the newly added item into view
      const element = document.getElementById(`menu-item-${item.id}`)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }
    })
  }

  const recursivelyDeleteChildren = (item) => {
    const newData = JSON.parse(JSON.stringify(items.value))

    for (const key in newData) {
      if (newData[key].parent_id === item.id) {
        recursivelyDeleteChildren(newData[key])

        delete newData[key]
      }
    }

    items.value = newData
  }

  const removeItem = (item) => {
    const newData = JSON.parse(JSON.stringify(items.value))

    recursivelyDeleteChildren(item)

    delete newData[item.id]

    items.value = newData

    if (selectedItem.value && selectedItem.value.id === item.id) {
      deselectItem()
    }
  }

  const createOption = (name, component, icon, action) => ({ name, component, icon, action })

  const elementOptions = computed(() => [
    createOption('Link', 'Link', Link, (parent = null) => addItem(createLink(), parent)),
    createOption('Dropdown', 'Dropdown', SquareMenu, (parent = null) => addItem(createDropdown(), parent)),
    createOption('Categories', 'Categories', Tags, (parent = null) => addItem(createCategories(), parent)),
  ])

  return {
    // items
    createOption,
    elementOptions,
    items,
    addItem,
    removeItem,

    // selectedItem,
    selectedItem,
    selectItem,
    deselectItem,
  }
}
